import startCase from "lodash/fp/startCase";
import groupBy from "lodash/fp/groupBy";
import moment from "moment";
import { saveAs } from "file-saver";

class Controller {
  constructor(
    $stateParams,
    Events,
    InvoiceItemType,
    BulkInvoiceItemTypesUploadDetailsTransforms
  ) {
    "ngInject";

    this.$stateParams = $stateParams;
    this.InvoiceItemType = InvoiceItemType;
    this.BulkInvoiceItemTypesUploadDetailsTransforms = BulkInvoiceItemTypesUploadDetailsTransforms;
    this.Events = Events;
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
  }

  $onInit() {
    this.InvoiceItemType.getFile(this.$stateParams.id)
      .$promise.then((response) => {
        this.getHeaders(response.invoice_item_type);
        this.invoiceItemType = startCase(response.invoice_item_type);
        this.createdAt = response.createdAt;
        this.status = response.status;
        this.records = this.BulkInvoiceItemTypesUploadDetailsTransforms.justifyRecords(
          response.records
        );
        this.groupedRecords = groupBy("status")(this.records);
        this.totals = {
          succeeded: response.number_of_successful_records,
          failed: response.number_of_failed_records,
          pending:
            response.number_of_records -
            response.number_of_successful_records -
            response.number_of_failed_records,
        };
      })
      .catch((err) => this.Events.emit(this.errorNotificationEvent, err.data));
  }

  getHeaders(invoiceItemType) {
    this.InvoiceItemType.getTransactionFileTypes()
      .$promise.then((response) => {
        const type = response.find(({ type }) => type === invoiceItemType) || {
          fields: [],
        };
        const allFields = type.fields.map(({ name }) => ({
          name,
          title: startCase(name),
        }));

        this.fields = {
          succeeded: allFields,
          pending: allFields,
          failed: [...allFields, { name: "error", title: "Error" }],
        };
      })
      .catch((err) => this.Events.emit(this.errorNotificationEvent, err.data));
  }

  downloadCSV() {
    const newRowRegex = "\r\n";
    const filteredData = this.records.map((cell) => {
      return this.fields[this.status].reduce((acc, { name }) => {
        acc[name] = cell[name];

        return acc;
      }, {});
    });
    const columns = this.fields[this.status].map(({ name }) => name).join(",");
    const rows = filteredData.reduce((rows, row) => {
      return rows.concat(Object.values(row).join(",") + newRowRegex);
    }, "");
    const parsedData = columns + newRowRegex + rows;

    const csvFile = new File(
      [parsedData],
      `Bulk Bonus Upload ${moment(this.createdAt).format("LL")}.csv`
    );
    saveAs(csvFile);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/bulkInvoiceItemTypesUploadDetails/bulkInvoiceItemTypesUploadDetails.controller.js